import React from 'react';
import styles from './FormulariSubscripcio.module.scss';
import Boto from 'components/corporatiu/Boto';

export default function FormulariSubscripcio() {
    return (
        <>
            <p>
                <strong className={styles.introText}>
                    Si vols rebre les informacions del departament de Comunicació, envia&apos;ns les teves dades.
                </strong>
            </p>
            <div className={styles.desplegable}>
                <div className={styles.texto}>
                    <div className={styles['R-formulariRegiste']}>
                        <form
                            action='https://www.3cat.cat/su/Register'
                            method='post'
                            name='Participa'
                            encType='multipart/form-data'
                            id='Participa'
                        >
                            <div className={styles.dades}>
                                <div className={styles.formField}>
                                    <label htmlFor='NOM' className={styles.required}>
                                        Nom
                                    </label>
                                    <input type='text' id='NOM' name='NOM' required />
                                </div>
                                <div className={styles.formField}>
                                    <label htmlFor='COGNOMS' className={styles.required}>
                                        Cognoms
                                    </label>
                                    <input type='text' id='COGNOMS' name='COGNOMS' required />
                                </div>
                                <div className={styles.formField}>
                                    <label htmlFor='MITJACOM'>Mitjà de comunicació</label>
                                    <input type='text' id='MITJACOM' name='MITJACOM' />
                                </div>
                                <div className={styles.formField}>
                                    <label htmlFor='SECCIO'>Secció</label>
                                    <input type='text' id='SECCIO' name='SECCIO' />
                                </div>
                                <div className={styles.formField}>
                                    <label htmlFor='CORREU'>Correu electrònic</label>
                                    <input type='email' id='CORREU' name='CORREU' />
                                </div>
                                <div className={styles.formField}>
                                    <label htmlFor='TELEFON'>Telèfon de contacte</label>
                                    <input type='text' id='TELEFON' name='TELEFON' />
                                </div>
                                <div className={styles.formField}>
                                    <label htmlFor='WEB'>Web</label>
                                    <input type='text' id='WEB' name='WEB' />
                                </div>
                                <div className={styles.formField}>
                                    <label htmlFor='ADRECA'>Adreça</label>
                                    <input type='text' id='ADRECA' name='ADRECA' />
                                </div>
                                <div className={styles.formField}>
                                    <label htmlFor='POBLACIO'>Població</label>
                                    <input type='text' id='POBLACIO' name='POBLACIO' />
                                </div>
                                <div className={styles.formField}>
                                    <label htmlFor='CODIPOSTAL'>Codi postal</label>
                                    <input type='text' id='CODIPOSTAL' name='CODIPOSTAL' />
                                </div>

                                <div className={styles.formField}>
                                    <label htmlFor='IMGID'>Escriu el codi de la imatge</label>
                                    <div className={styles.img_captcha}>
                                        <img
                                            alt='Imatge del codi captcha'
                                            src={`https://www.3cat.cat/su/shared/image.jsp?imgId=${Math.random()}`}
                                        />
                                        <input value='IMGID' id='hiImgNumber' name='hiImgNumber' type='hidden' />
                                    </div>
                                    <input name='IMGID' id='IMGID' type='text' className={styles.camp_captcha} required />
                                </div>
                                <div className={styles.formField}>
                                    <input name='tos_checkbox' id='tos_checkbox' type='checkbox' required />
                                    <label htmlFor='tos_checkbox'>
                                        He llegit i accepto la{' '}
                                        <a href='https://www.3cat.cat/avis-legal/privacitat/premsa/' className={styles.linkForm}>
                                            política de privacitat
                                        </a>
                                    </label>
                                </div>

                                <input name='hiTarget' type='hidden' value='/premsa/subscripcio/ok' />
                                <input name='hiErrTarget' type='hidden' value='/premsa/subscripcio/ko' />

                                <input type='hidden' name='hiRegServiceId' value='PU_SALAPREMSA_CON' />
                                <input type='hidden' name='hiServiceId' value='PU_SALAPREMSA_CON' />
                                <input type='hidden' name='from' value='no_reply@tv3.cat' />
                                <input type='hidden' name='hiAction' value='254' />

                                <div>
                                    <Boto text='Envia' estil='neutral' tag='button' />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}
